import React, { useContext } from 'react';

import { IconButton, Size, MatchHeight } from '@americanexpress/aqx-components';

import { ToggleModalContext } from 'page_modules/compare/index';

import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

import styles from '../__styles__/emptyCardSlot.scss?modules';

const EmptyCardSlot = () => {
  const toggleModal = useContext(ToggleModalContext);
  const onClick = () => {
    toggleModal();
    sendDTMClickEvent({
      eventAction: 'click',
      eventAsset: `AddCard`
    });
  };
  return (
    <div className={styles.container}>
      <div className={styles.placeHolder}>
        <MatchHeight name="desktop-header-tier1-badge">
          <div className={styles.placeHolder} />
        </MatchHeight>
      </div>
      <div className={styles.iconButtonContainer}>
        <IconButton
          $size={Size.LG}
          onClick={onClick}
          imageName="dls-icon-plus-circle"
          ariaLabel={`Add a card to compare`}
        />
      </div>
    </div>
  );
};

export default EmptyCardSlot;
